import React, { Component } from 'react';
import { Button, Checkbox, IconButton, Grid, withStyles, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { EVENT_IMG } from '../constatns';
// import { withCookies, Cookies } from 'react-cookie';
import moment from 'moment';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { BsArrowLeftCircle, BsArrowRightCircle } from 'react-icons/bs';

import { withCookies } from 'react-cookie';
import './EventDialog.css';
import zIndex from '@material-ui/core/styles/zIndex';

const styles = (theme) => ({
  CheckboxCss: {
    // '&.MuiIconButton-label': {
    //   color: '#fff',
    //   backgroundColor: '#fff',
    // },
  },
});
class EventDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSave: false,
    };
    this.goToPage = this.goToPage.bind(this);
    this.changeSave = this.changeSave.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  goToPage(_move) {
    this.props.history.push(_move);
  }

  changeSave(e) {
    this.setState({ isSave: e.target.checked });
  }
  handleClose() {
    this.saveCookie();
    this.props.onClose();
  }

  saveCookie() {
    let momentDate = moment();
    if (this.state.isSave) {
      if (!this.props.cookies.get('popupCookie')) {
        this.props.cookies.set('popupCookie', true, { path: '/', expires: momentDate.add(24, 'hours').toDate() });
      }
    } else {
      this.props.cookies.remove('popupCookie');
    }
  }

  renderArrows() {
    return (
      <div className="slider-arrow">
        <Button className="arrow-btn prev" onClick={() => this.slider.slickPrev()}>
          <BsArrowLeftCircle size={30} color="primary" />
        </Button>
        <Button className="arrow-btn next" onClick={() => this.slider.slickNext()}>
          <BsArrowRightCircle size={30} color="primary" />
        </Button>
      </div>
    );
  }

  render() {
    const { classes } = this.props;
    const settings = {
      // dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 5000,
    };

    return (
      <div style={{ width: '100%' }} onClose={this.props.onClose}>
        <Grid container justifyContent="center">
          <Grid container item xs={11} sm={10} md={9} lg={9} style={{ paddingBottom: 16 }}>
            <Grid item xs={1}></Grid>
            <Grid container justifyContent="center" item xs={10}>
              <Typography style={{ fontSize: '40px', fontWeight: 'bold' }}> PRS KOREA 2022 POPUP </Typography>
            </Grid>
            <Grid container justifyContent="center" alignItems="center" item xs={1}>
              <IconButton
                aria-label="close"
                className={classes.closeButton}
                onClick={
                  this.handleClose

                  // this.props.onClose
                }
                style={{ color: '#fff', padding: 0 }}
              >
                <CloseIcon style={{ fontSize: '48px' }} />
              </IconButton>
            </Grid>
          </Grid>
          <Grid container justifyContent="center" item xs={12}>
            <Grid
              container
              item
              justifyContent="center"
              style={{
                backgroundImage: `url('/images/PRS2022/main_is_bg.png')`,
                borderRadius: 10,
                maxWidth: 500,
                height: 500,
                padding: 20,
                margin: '0 10px',
              }}
            >
              <Grid
                container
                style={{ width: '100%', height: '100%', backgroundColor: '#fff', borderRadius: 10, padding: 20, position: 'relative' }}
              >
                <Typography style={{ fontSize: 20, color: '#000', fontFamily: 'GmarketSansBold', textAlign: 'center' }}>
                  To get Receipt and Certificate of Attendance for PRS KOREA 2022
                </Typography>

                <Typography style={{ fontSize: 16, color: '#000', fontFamily: 'GmarketSansMedium' }}>
                  All Participants who registered for PRS KOREA 2022 can download the Receipt and Certificate on the website.
                </Typography>
                <Typography style={{ fontSize: 16, color: '#002060', fontFamily: 'GmarketSansBold' }}>
                  How to get Receipt and Certificate of
                  <br />
                  PRS KOREA 2022
                </Typography>
                <Typography style={{ fontSize: 16, color: '#000', fontFamily: 'GmarketSansMedium', lineHeight: 1.6 }}>
                  1. Log-in at PRS KOREA 2022 Website.
                  <br />
                  2. Click on the “My Page” and go to
                  <br />
                  &nbsp;&nbsp;&nbsp;“Registration”.
                  <br />
                  3. Click on the “Receipt” and “Certificate” button
                  <br />
                  &nbsp;&nbsp;&nbsp;to download.
                </Typography>
                {/* <Typography style={{ fontSize: 16, color: '#000', fontFamily: 'GmarketSansMedium' }}>
              
                </Typography>
                <Typography style={{ fontSize: 16, color: '#000', fontFamily: 'GmarketSansMedium' }}>
      
                </Typography> */}
                <Grid item xs={12}>
                  <Button
                    fullWidth
                    variant="contained"
                    color="primary"
                    style={{ textTransform: 'none', fontSize: 18, fontFamily: 'GmarketSansBold', height: 68 }}
                    onClick={() => {
                      this.props.goToPage('/mypage');
                    }}
                  >
                    Go to My Page
                  </Button>
                </Grid>
              </Grid>
            </Grid>
            <Grid
              container
              item
              justifyContent="center"
              style={{
                // backgroundImage: `url('/images/PRS2022/main_is_bg.png')`,
                background: `linear-gradient(90deg, rgba(255,200,70,1) 20%, rgba(243,150,0,1) 70%)`,
                borderRadius: 10,
                maxWidth: 500,
                height: 500,
                padding: 20,
                margin: '0 10px',
              }}
            >
              <Grid container style={{ width: '100%', height: '100%', backgroundColor: '#fff', borderRadius: 10, padding: 20 }}>
                <Typography style={{ fontSize: 20, color: '#000', fontFamily: 'GmarketSansBold', textAlign: 'center' }}>
                  PRS KOREA 2022 Program Book & Abstract Book Download
                </Typography>
                <Typography style={{ fontSize: 16, color: '#000', fontFamily: 'GmarketSansMedium' }}>
                  All Participants of PRS KOREA 2022 can download the Program Book and Abstract Book on the website.
                </Typography>
                <Typography style={{ fontSize: 16, color: '#f39600', fontFamily: 'GmarketSansBold' }}>
                  Click the button below to download Program Book and Abstract Book
                  <br />
                  <b style={{ color: '#f00' }}>(For registered users only.)</b>
                </Typography>
                <Grid item xs={12}>
                  <Button
                    fullWidth
                    variant="contained"
                    // color="secondary"
                    style={{ textTransform: 'none', fontSize: 18, fontFamily: 'GmarketSansBold', backgroundColor: '#f39600', height: 68 }}
                    onClick={() => {
                      this.props.goToPage('/downloads');
                    }}
                  >
                    Go to Download
                  </Button>
                </Grid>
              </Grid>
            </Grid>
            {/* <div>
              <img
                src={`${EVENT_IMG}/popup_01.png`}
                alt=""
                style={{ width: '90%', cursor: 'pointer', margin: 'auto' }}
                onClick={() => {
                  this.props.goToPage('registration/guide');
                }}
              />
            </div>

            <div>
              <img
                src={`${EVENT_IMG}/popup_01.png`}
                alt=""
                style={{ width: '90%', cursor: 'pointer', margin: 'auto' }}
                onClick={() => {
                  this.props.goToPage('registration/guide');
                }}
              />
            </div> */}
            {/* <Slider {...settings} style={{ width: '100%' }}>
            
              <div>
                <img
                  src={`${EVENT_IMG}/popup_a.png`}
                  alt=""
                  style={{ width: '90%', margin: 'auto' }}
                  onClick={() => (window.location.href = 'mailto:academic.kprs@innon.co.kr')}
                />
                <div style={{ position: 'relative' }}>
                  <div style={{ position: 'relative', width: '100%', height: '100%' }}>
                    <div
                      style={{
                        position: 'absolute',
                        height: 40,
                        width: 256,
                        bottom: 50,
                        left: 80,
                        cursor: 'pointer',
                        zIndex: 999,
                        border: '2px solid red',
                      }}
                      onClick={() => (window.location.href = 'mailto:academic.kprs@innon.co.kr')}
                    >
            
                    </div>
                    <img src={`${EVENT_IMG}/popup_a.png`} alt="" style={{ width: '90%', margin: 'auto' }}   onClick={() => (window.location.href = 'mailto:academic.kprs@innon.co.kr')}/>
                  </div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <div
                    style={{
                      width: '90%',
                      height: 354,
                      padding: '20px 0',
                      backgroundColor: 'white',
                      backgroundImage:
                        'linear-gradient(90deg, rgb(170,203,60,0.5)50%, transparent 50%),linear-gradient(rgb(35,122,157,0.5) 50%, transparent 50%)',
                      backgroundSize: '50px 50px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <div style={{ width: '95%', height: '95%', backgroundColor: '#fff' }}>
                      <div style={{ display: 'flex', justifyContent: 'center', margin: '9px 0' }}>
                        <img alt="" src={`${EVENT_IMG}/ic/ic_mail.png`} />
                      </div>
                      <div
                        style={{
                          textAlign: 'center',
                          fontWeight: 'bold',
                          color: '#000',
                          fontSize: 16,
                          marginBottom: 18,
                          fontFamily: 'GmarketSansTTFBold',
                          backgroundColor: '#fff',
                        }}
                      >
                        Acceptance Notification & Guideline for
                        <br />
                        abstract were sent out to Presenting &<br />
                        Corresponding Authors by E-mail.
                      </div>
                      <div
                        style={{
                          textAlign: 'center',
                          color: '#000',
                          fontSize: 14,
                          fontFamily: 'GmarketSansTTFMedium',
                          backgroundColor: '#fff',
                        }}
                      >
                        If you have not received an E-mail,
                        <br /> Please contact the conference secretariat.
                        <br />(<a href={'mailto:academic.kprs@innon.co.kr'}>academic.kprs@innon.co.kr</a>)
                      </div>
                    </div>
                  </div>
                </div>
              </div>

      
              <div>
                <img
                  src={`${EVENT_IMG}/popup_01.png`}
                  alt=""
                  style={{ width: '90%', cursor: 'pointer', margin: 'auto' }}
                  onClick={() => {
                    this.props.goToPage('registration/guide');
                  }}
                />
              </div>

      
              <div>
                <img
                  src={`${EVENT_IMG}/popup_03.png`}
                  alt=""
                  style={{ width: '90%', cursor: 'pointer', margin: 'auto' }}
                  onClick={() => {
                    this.props.goToPage('/choose');
                  }}
                />
              </div>

      
              <div>
                <img
                  src={`${EVENT_IMG}/popup_04.png`}
                  alt=""
                  style={{ width: '90%', cursor: 'pointer', margin: 'auto' }}
                  onClick={() => {
                    this.props.goToPage('/info/accommodation');
                  }}
                />
              </div>
            </Slider> */}
          </Grid>

          <Grid container justifyContent="center" alignItems="center" style={{ paddingTop: '10px' }}>
            <Checkbox
              color="primary"
              className={classes.CheckboxCss}
              //  icon={<CustomCheckBox />}

              checked={this.state.isSave}
              onChange={(e) => this.changeSave(e)}
            />
            <Typography style={{ fontSize: '18px' }}>Not Open for 24 hours</Typography>
          </Grid>
        </Grid>
      </div>
    );
  }
}
export default withCookies(withStyles(styles, { withTheme: true })(EventDialog));
